import { Input } from "antd";
import React from "react";
import "@/styles/components/searchBar.scss";

const SearchBar = ({ onSearch = () => {} }) => {
  const { Search } = Input;
  const handleSearch = (value, _e, info) => {
    onSearch(value);
  };

  return (
    <Search
      placeholder="Search..."
      onSearch={handleSearch}
      onChange={(e) => {
        if (!e.target.value) {
          onSearch(e.target?.value);
        }
      }}
      size="large"
      className="search-bar"
      classNames={{
        groupWrapper: "search-bar-group-wrapper",
        input: "search-bar-input",
      }}
      enterButton
      style={{ width: "fit-content" }}
    />
  );
};

export default SearchBar;
